export default "__VITE_PUBLIC_ASSET__992ab950__"